export function matchesGlobalFilter(
  query: string,
  searchableValues: readonly (string | number | boolean | null | undefined)[],
): boolean {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) {
    return true;
  }

  return searchableValues.some((value) => {
    if (value === null || value === undefined) {
      return false;
    }
    const normalizedValue = String(value).toLowerCase();
    return (
      normalizedValue.length > 0 && normalizedValue.includes(normalizedQuery)
    );
  });
}
